import React from 'react';
import { withRouter } from 'react-router-dom';
import { Field as FField } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import { Col, Row } from 'antd';
import { StyledTitle as Title } from '../../fields/Title';
import { CheckboxInputControl, InputControl } from '../../fields/Fields';

import NotSure from '../../../assets/onboarding/goals/not-sure.svg';
import ImproveGrades from '../../../assets/onboarding/goals/improve-grades.svg';
import PerformanceTracking from '../../../assets/onboarding/goals/performance-tracking.svg';
import IncreaseEngagement from '../../../assets/onboarding/goals/increase-engagement.svg';
import IdentifyLearningStyles from '../../../assets/onboarding/goals/identify-learning-styles.svg';

import Icon from '@ant-design/icons';
import { Img, YellowUnderline } from '../../../styles/StyledComponents';

// eslint-disable-next-line
const OPTIONS_OBJ = {
  'Increase engagement': '#D7753E',
  'Performance tracking': '#5BBCBD',
  'Identify learning styles': '#FF8BA7',
  'Improve grades': '#8053D7'
};

const GoalsForm = ({ match }) => {
  return (
    <Row justify='center' align='middle' style={{ padding: '50px 10px' }}>
      <Col xl={22} xs={22}>
        <YellowUnderline>
          <Title level={3}>
            <FormattedMessage
              id={`on-boarding.${match.params.step}.main.title`}
            />
          </Title>
        </YellowUnderline>
        <small style={{ textAlign: 'center' }}>Please select your goals:</small>
        <Row gutter={[16, 16]}>
          <Col xl={8} xs={20} style={{ paddingBottom: 20 }}>
            <FField
              name='goals'
              value='increase-engagement'
              type='checkbox'
              component={CheckboxInputControl}
              icon={
                <Icon
                  component={() => <Img src={IncreaseEngagement} width={150} />}
                />
              }
            />
          </Col>
          <Col xl={8} xs={20} style={{ paddingBottom: 20 }}>
            <FField
              name='goals'
              value='improve-grades'
              type='checkbox'
              component={CheckboxInputControl}
              icon={
                <Icon
                  component={() => <Img src={ImproveGrades} width={150} />}
                />
              }
            />
          </Col>
          <Col xl={8} xs={20} style={{ paddingBottom: 20 }}>
            <FField
              name='goals'
              value='identify-learning-styles'
              type='checkbox'
              component={CheckboxInputControl}
              icon={
                <Icon
                  component={() => (
                    <Img src={IdentifyLearningStyles} width={150} />
                  )}
                />
              }
            />
          </Col>
          <Col xl={8} xs={20} style={{ paddingBottom: 20 }}>
            <FField
              name='goals'
              value='performance-tracking'
              type='checkbox'
              component={CheckboxInputControl}
              icon={
                <Icon
                  component={() => (
                    <Img src={PerformanceTracking} width={150} />
                  )}
                />
              }
            />
          </Col>
          <Col xl={8} xs={20} style={{ paddingBottom: 20 }}>
            <FField
              name='goals'
              value='not-sure'
              type='checkbox'
              component={CheckboxInputControl}
              icon={
                <Icon component={() => <Img src={NotSure} width={150} />} />
              }
            />
          </Col>
        </Row>
        <Col xl={22} xs={22}>
          <YellowUnderline>
            <Title level={3}>How many students do you teach?</Title>
          </YellowUnderline>
          <FField
            name='avgClassSize'
            component={InputControl}
            style={{ maxWidth: 300 }}
            type='number'
            placeholder='21'
          />
        </Col>
        <br />
        <br />
      </Col>
    </Row>
  );
};

export default withRouter(GoalsForm);
